//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from "jquery";

import { validationMixin } from "vuelidate";
import { required, email, numeric } from "vuelidate/lib/validators";
import { isValidNumber, parseNumber } from "libphonenumber-js";

import qs from "qs";

import storage from "local-storage-fallback";
import countryBlocker from "~/middleware/country";

export default {
    data() {
        return {
            title: "Please RSVP now as places are limited",
            thankYouMessage: "Thank you for registering, we look forward to seeing at our Brand launch",
            unableToAttendMode: false,
            calendarmode: false,
            hasEmail: false,
            email: "",
            first_name: "",
            last_name: "",
            company_name: "",
            location: {},
            source: "",
            isFormLoading: false,
            isFormSuccess: false,

            phone: "",
            country: "",
            countryListOpen: false,
            phoneFieldFocused: false,
            phoneUpdated: false,
            countryList: [
                {
                    name: "Australia",
                    code: "AU",
                    dial: "61",
                },
                {
                    name: "Canada",
                    code: "CA",
                    dial: "1",
                },
                {
                    name: "Hong Kong",
                    code: "HK",
                    dial: "852",
                },
                {
                    name: "New Zealand",
                    code: "NZ",
                    dial: "64",
                },
                {
                    name: "Philippines",
                    code: "PH",
                    dial: "63",
                },
                {
                    name: "Singapore",
                    code: "SG",
                    dial: "65",
                },
                {
                    name: "United Kingdom",
                    code: "GB",
                    dial: "44",
                },
                {
                    name: "United States",
                    code: "US",
                    dial: "1",
                },
            ],
            errors: {
                phone: "",
            },
        };
    },
    computed: {
        zapURL() {
            return process.env.ZAP_LAUNCH_INVITE;
        },
        zapURLUnable() {
            return process.env.ZAP_LAUNCH_INVITE_UNABLE;
        },
        phoneFull() {
            return this.phone ? this.countrySelected.dial + this.phone : "";
        },
        countrySelected() {
            const self = this;
            return (
                this.countryList.filter((c) => c.name === self.country)[0] || {
                    name: "Australia",
                    code: "AU",
                    dial: "61",
                }
            );
        },
        countryListReverse() {
            return [].sort.call(this.countryList, function (a, b) {
                return b.name.localeCompare(a.name);
            });
        },
    },
    async mounted() {
        try {
            await this.$recaptcha.init();
        } catch (e) {
            console.error(e);
        }
    },
    async created() {
        this.country = "Australia";

        if (process.browser || process.client) {
            const self = this;
            await countryBlocker(this.$nuxt.context);

            self.localStorage = !("localStorage" in window) ? storage : window.localStorage;

            const burstGeo = JSON.parse(self.localStorage.getItem("burst-geo-2"));

            self.source = window.location.href;

            if (burstGeo) {
                self.location.ip = burstGeo.ip || "";
                self.location.country_code = burstGeo.country_code || "";

                self.location.timestamp = new Date().toISOString().split(".")[0].replace("T", " ");

                if (burstGeo.data) {
                    self.location.country_name = burstGeo.data.country_name || "";
                    self.location.time_zone = burstGeo.data.time_zone.name || "";
                    self.location.zip = burstGeo.data.zipcode || "";
                    self.location.latitude = burstGeo.data.latitude || "";
                    self.location.longitude = burstGeo.data.longitude || "";
                }
            }

            // Check if unable to attend

            const urlParams = new URLSearchParams(window.location.search);
            const hasRSVPUnable = urlParams.has("rsvp") && urlParams.get("rsvp") === "unable";
            const hasCalendarMode = urlParams.has("rsvp") && urlParams.get("rsvp") === "calendar";
            const hasEmail = urlParams.get("email") || false;
            if (hasRSVPUnable) {
                this.goBackUnable();
            }

            if (hasEmail && hasRSVPUnable) {
                this.email = hasEmail;
                this.goSubmitUnable();
            }

            if (hasCalendarMode) {
                this.isFormSuccess = true;
                this.calendarmode = true;
            }
        }
    },
    mixins: [validationMixin],
    validations: {
        first_name: {
            required,
        },
        last_name: {
            required,
        },
        company_name: {
            required,
        },
        phone: {
            numeric,
            phone(phone) {
                // if (phone === "") return true;
                const country = this.countrySelected.code;

                this.phoneUpdated = true;

                const isValid = isValidNumber(phone, country);
                if (isValid) {
                    this.phone = parseNumber(phone, country, {
                        extended: true,
                    }).phone;
                }
                return isValid;
            },
            submitErrors(phone) {
                if (this.phoneUpdated) return true;

                return this.errors.phone === "";
            },
        },
        email: {
            required,
            email,
        },
    },
    methods: {
        focusInvalidField() {
            const _fields = [
                { id: "company_name", name: "Company Name" },
                { id: "first_name", name: "First Name" },
                { id: "last_name", name: "Last Name" },
                { id: "phone", name: "Phone" },
                { id: "email", name: "Email" },
            ];

            for (let i = 0; i < _fields.length; i++) {
                if (this.$v[_fields[i].id].$invalid) {
                    this.$refs.form.querySelector('[name="' + _fields[i].name + '"]').focus();
                    break;
                }
            }
        },
        goBackRSVP() {
            this.unableToAttendMode = false;
            this.title = "Please RSVP now as places are limited";
        },
        goBackUnable() {
            this.unableToAttendMode = true;
            this.title = "I'm unable to attend the Brand Launch";
        },
        goSubmitUnable() {
            const self = this;

            if (this.$v.email.$invalid) return;

            this.isFormLoading = true;
            this.thankYouMessage = "Thank you for your response";

            $.ajax({
                type: "POST",
                url: this.zapURLUnable,
                data: {
                    email: this.email,
                    source: this.source,
                },
                dataType: "json",
            }).then(function () {
                self.isFormLoading = false;
                self.isFormSuccess = true;
            });
        },
        goSubmit() {
            const self = this;

            this.isFormLoading = true;

            $.ajax({
                type: "POST",
                url: this.zapURL,
                data: {
                    company_name: this.company_name,
                    first_name: this.first_name,
                    last_name: this.last_name,
                    phone: this.phoneFull,
                    email: this.email,
                    time_stamp: new Date().toISOString(),
                    location: this.location,
                    source: this.source,
                },
                dataType: "json",
            }).then(function () {
                self.isFormLoading = false;
                self.isFormSuccess = true;
            });
        },
        async onFormSubmit() {
            // Validate form
            const self = this;

            this.$v.$touch();
            if (this.$v.$invalid) {
                this.focusInvalidField();
                return;
            }

            try {
                const token = await this.$recaptcha.execute("launch_invite");

                // send token to server alongside your form data
                this.isFormLoading = true;
                this.$axios({
                    url: "/.netlify/functions/captcha",
                    baseURL: "/",
                    method: "POST",
                    data: qs.stringify({
                        token,
                    }),
                }).then(function (response) {
                    if (response?.data?.success && response?.data?.score > 0.5) {
                        self.goSubmit();
                    } else {
                        // self.setErrorByCode("API_FAIL");
                    }
                });
            } catch (error) {
                console.error("Login error:", error);
                // self.setErrorByCode("API_FAIL");
            }
        },
        classValid(field) {
            let _class = "";
            if (this.$v[field].$dirty) {
                _class += "is-dirty ";

                if (this.$v[field].$pending) {
                    _class += "is-loading ";
                    return _class;
                }
                if (this.$v[field].$invalid) {
                    _class += "is-invalid ";
                } else {
                    _class += "is-valid ";
                }
            }

            if (field === "phone") {
                if (this.phoneFieldFocused) _class += "is-focused ";
            }

            return _class;
        },

        isNumber(event) {
            if (isNaN(Number(event.key))) {
                return event.preventDefault();
            }
        },
        phoneOnFocus() {
            this.phoneFieldFocused = true;
        },
        phoneOnChange() {
            this.$v.phone.$touch();
        },
        changeCountry(country) {
            if (this.countryListOpen) {
                if (this.country !== country) {
                    this.country = country;

                    if (this.phone.length > 0) {
                        this.phoneOnChange();
                    }
                }
            }
            this.toggleCountryList();
        },
        toggleCountryList() {
            this.$v.phone.$touch();
            this.countryListOpen = !this.countryListOpen;
        },
    },
};
